// extracted by mini-css-extract-plugin
export default {"wrapper":"Z0Km26","blueonhoverTheme":"dYVn4i","blueTheme":"PSszVD"};